import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import StreamerPage from "./components/StreamerPage";
import VideoPage from "./components/VideoPage";
import "./App.css";

// Import streamer data directly from data directory
import arrowwoodsData from "./data/arrowwoods.json";
import dobrorulituraData from "./data/dobrorulitura.json";
import archiedosData from "./data/archiedos.json";

// Create a map of streamer data
export const streamersData = {
  arrowwoods: arrowwoodsData,
  dobrorulitura: dobrorulituraData,
  archiedos: archiedosData,
};

// Get list of streamers
export const streamers = Object.keys(streamersData);

// Mapping for streamer display names with custom font cases
export const streamerDisplayNames = {
  arrowwoods: "Arrowwoods",
  dobrorulitura: "DobroRulitUra",
  archiedos: "Archiedos",
};

// Helper function to get display name for a streamer
export const getStreamerDisplayName = (streamer) => {
  return streamerDisplayNames[streamer] || streamer;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:streamer" element={<StreamerPage />} />
          <Route path="/:streamer/page/:page" element={<StreamerPage />} />
          <Route path="/:streamer/:videoId" element={<VideoPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
